import { useLayoutEffect } from "react";

import { useParams } from "react-router-dom";

import useTranscript from "@app/analytics/MeetingReport/hooks/useTranscript";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import { toast } from "@app/common/hooks/useToasts";

import { Link } from "@rui/Link";

const useTranscriptEditedToast = () => {
  const { sessionId } = useParams();

  const [dismissed, setDismissed] = useLocalStorage(
    `meetingReportTranscriptEditedBannerDismissed_${sessionId}`,
    false,
    { scope: "session" }
  );

  const { isEdited } = useTranscript();

  const showToast = Boolean(sessionId) && isEdited && !dismissed;

  useLayoutEffect(() => {
    if (!showToast) return;
    toast.info({
      type: "system",
      title: "Edits may affect accuracy",
      message:
        "Deep Dive and Coaching do not take into account edits made to the transcript. Attribution on these pages are based on the original transcript.",
      sticky: true,
      dismissible: true,
      disableClickAway: true,
      action: (
        <Link onClick={() => setDismissed(true)} fontWeight={500} py={1}>
          Dismiss
        </Link>
      ),
    });
  }, [showToast]);
};

export default useTranscriptEditedToast;
